import { motion, useInView } from "framer-motion";

import ManagementCertification from "../../components/management_certification";

import { useEffect, useRef, useState } from "react";
import GlobalBanner from "../../components/banner";

import {
  managementCertificationsDiscList,
  projects,
} from "../../utilities/projectsData";
import DefaultPadding from "../../utilities/constants";

import styles from "../../style/style.module.css";
import DancingLetters from "../../components/dancingLetters";
import Button from "../../components/button";
import CountryAccordion from "../../components/project/countryAccordion";
import ProjectBanner from "../../assets/banner/ProjectBanner.png";
const Projects = () => {
  const [isOpen, setIsOpen] = useState(null);

  const ref = useRef();
  const isInView = useInView(ref, { amount: 0.5, once: true });

  const staggeredAnimation = {
    hidden: {
      opacity: 0,
      x: 150,
    },
    visible: (index) => ({
      opacity: 1,
      x: 0,
      transition: {
        delay: 0.15 * index,
        duration: 0.5,
      },
    }),
  };

  document.title = "Projects";
  useEffect(() => {
    window.scroll({
      top: 0,
      behavior: "instant",
    });
  }, []);

  const padding = new DefaultPadding();
  const defaultPaddingX = padding.getDefaultPaddingX();

  return (
    <>
      <GlobalBanner
        bannerImg={ProjectBanner}
        discription={
          "Explore our diverse project portfolio and witness our expertise across telecommunications, network benchmarking, field performance testing, and more. Find inspiration in our impactful work."
        }
      >
        <span className="text-visOrange"> Our Projects </span>
      </GlobalBanner>
      <section className={`${defaultPaddingX} py-[7vw]`}>
        <p>
          Vis Group is dedicated to providing comprehensive outsourcing options
          for a wide range of industries, including telecommunications, network
          benchmarking, field performance testing, infotainment system testing,
          GPS and mobile application testing, manual and automation testing,
          software development, and related services. Our highly skilled
          technicians and engineers are available for project-based deployments,
          eliminating the need for permanent employees on your side. With our
          agile approach, we can swiftly allocate resources to any location
          within Europe and worldwide. Partner with Vis Group for efficient and
          reliable outsourcing solutions tailored to meet your specific needs.
        </p>
        <div className="mt-10 flex flex-col space-y-0">
          {projects.map((proj, index) => {
            return (
              <motion.div
                key={proj.label + index}
                ref={ref}
                variants={staggeredAnimation}
                initial={"hidden"}
                animate={isInView ? "visible" : "hidden"}
                custom={index}
                className="space-y-2 even:bg-visLightGray"
              >
                <CountryAccordion
                  countries={proj.countries}
                  title={proj.label}
                  open={isOpen === index}
                  click={() => setIsOpen(isOpen === index ? null : index)}
                />
              </motion.div>
            );
          })}
        </div>
      </section>

      {/* <EndingBanner buttonText='Consult with an expert now' /> */}
      <div className={`${styles.ourServices} `}>
        <div className="flex w-full flex-col items-center justify-center space-y-6 bg-visBlurBlue py-28 text-center text-white">
          <p className="text-xl font-bold md:text-3xl">
            <DancingLetters title={"Want to discuss your project?"} />
          </p>
          <Button href={"/contactus"}>
            <span className="px-10 text-white lg:px-20 lg:text-[16px] lg:leading-[26px]">
              Consult with an expert now
            </span>
          </Button>
          {/* <NavLink className="m-auto block w-fit rounded-sm bg-visOrange px-10 py-3 text-sm font-semibold text-white lg:px-20 lg:text-[16px] lg:leading-[26px]">
            Consult with an expert now
          </NavLink> */}
        </div>
      </div>

      <section className={`${defaultPaddingX} py-16`}>
        <ManagementCertification
          title={"We Are ISO Certified"}
          li={managementCertificationsDiscList}
        />
      </section>
    </>
  );
};

export default Projects;
